import React, { useContext, useEffect, useRef, useState } from "react";
import NavBar, { LiteNavBar } from "../../NavBar";
import { Navigate, Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Constants, { EditProfileMenu, FilterOptions, commonPopupButtonNames, commonPopupTitleNames,EventName,EventKeys } from "../../../Constants/constants";
import Pusher from "pusher-js";
import config from "../../../config";
import { useDispatch, useSelector } from "react-redux";
import { dashboardProfileData } from "../../../Store/DashboardAPI/Action";
import RouteSegments, { RouteHelper,RoutePaths } from "../../../Routes/RouteSegment";
import { ResetUnReadCount, UnreadMsgCount, getChatList, getConversationList, getCustomerServiceConversation, getGroupChatList, groupMessageReceived, messageReceived, reactionReceived, readbyReceived } from "../../../Store/Chats/Action";
import NotificationReceivedSound from "../../../sounds/notification-received.mp3";
import { getDeviceInfo, getGroupAuthId } from "../utils";
import { LoginContext } from "../../../Contexts/LoginContext";
import EndPoints from "../../../Constants/EndPoints";
import { GET, POST } from "../../../Services/api_services";
import { CommonNotificationAlertPopup, CommonNewPopup, CommonQualityPopup, KalyanRewardsPopup, RankingStartPopup, UploadPhotoPopuplite, CommonCastPopup, StarRaasiPopup, AstroPopup, CommonSuccessPopup, CommonUploadSuccessfull, CommonHoroPopup, UploadHoroscopeViaPopup ,CommonRewardPopup, CommonClcPhotoPopup,TrialPackExpiryPopup,CommonErrorPopup ,DoshamPopup} from "../../CommonPopup";
import { Update_Notification_Status } from "../../../Helpers/api_helpers";
import * as Icons from '../../../Components/Kalyanlite/assets/InitialPopupImages';
import ParentsPhonePopupLite from "../../DashboardComponents/ParentsPhonePopupLite";
import { loginUser } from "../../../Store/Login/Action";
import NotificationIcon from "../../Kalyanlite/assets/Images/notificationbell.svg"
import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from "../../../../src/firebase/firebaseConfig";
import { createPortal } from "react-dom";
import { getActivityTotalPoints, pointAwarded } from "../../../Store/KalyanRewards/Action";
import * as Images from "../../../Components/Kalyanlite/assets/images"
import { toast } from "react-toastify";
import { NavBarContext } from "../../../Contexts/NavBarContext";
import { getProfileMatch, getRecommendedMatches } from "../../../Store/KalyanLite/Action";
import ImageHoroscopePopup from "../../Edit Profile/ImageHoroscopePopup";
import { useTranslation } from "react-i18next";
import * as MatchSelector from "../../../Store/KalyanLite/selectors"
import ClcAddPhotoPopup from "../Popup/ClcAddPhotoPopup";
import PaymentPopup from "../Popup/PaymentPopup";
import { useAnalytics } from "../../../Hooks/usePageChange";
import ProfileDescriptionPopup from "../Popup/ProfileDescriptionPopup";
import {PaymentCLCPopup,PaymentCLCBigPopup} from "../../PaymentCLCPopup";
import kalyanlogo from "../../../Images/kalyanlogo.png";
import AddIdProofHoroscopePopup from "../../AddIdProofHoroscopePopup";
import axios from "axios";
import HoroComponent from '../../TrailPack/HoroComponent';
import TrustDocPopup from '../../../Pages/AfterRegistation/TrustDocPopup';
import DoshaDetailPopup from "../../../Components/DoshaDetailPopup"


let popUpImageSrc;

function LiteLayout() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [popupOpen, setPopupOpen] = useState()
  const [popUpContent, setPopupContent] = useState('')
  const [notificationId, setNotificationId] = useState()
  const [buttonName, setButtonName] = useState('');
  const [imageSrc, setImageSrc] = useState()
  const [title, setTitle] = useState()
  const [showParentNumPopup, setShowParentNumPopup] = useState(false);
  const { loginDetail, logout } = useContext(LoginContext);
  const initialref = useRef(false)
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const [showcastepopup, setShowCastePopup] = useState(false)
  const [showFamilyCodePopup, setShowFamilyCodePopup] = useState(false)
  const [showTrailPackPopup, setShowTrailPackPopup] = useState(false)
  const [showTrailPackCompletePopup, setShowTrailPackCompletePopup] = useState(false)
  const [showNotificationPermission, setShowNotificationPermission] = useState(false)
  const [showRewardsPopup, setShowRewardsPopup] = useState(false)
  const [showRankingPopup, setShowRankingPopup] = useState(false)
  const [from, setFrom] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [photopopupOpen, setPhotoPopupOpen] = useState(false);
  const [photonewpopupOpen, setPhotoNewPopupOpen] = useState(false);
  const [privacyPhotoPopupOpen, setPrivacyPhotoPopupOpen] = useState(false);
  const [clcaddphotopopup,setClcAddPhotoPopup] = useState(false)
  const [showUploadHoroscope, setshowUploadHoroscope] = useState(false);
  const [isFrom, setIsFrom] = useState("");
  const [showPaymentPopup, setShowPaymentPopup] = useState(false)
  const { onClickTrack } = useAnalytics();
 const [ showPhoto, setShowPhoto] = useState(false)
  const [uploadPhotoSuccessPopup, setUploadPhotoSuccessPopup] = useState(false)
  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false); // State to manage popup visibility

  const [paymentCLCsmallPopup, setPaymentCLCsmallPopup] = useState(false);
  const [paymentCLCbigPopup, setPaymentCLCbigPopup] = useState(false);
  const [familyChatAllow,setFamilyChatAllow] = useState(false)

   const [HoroIdProofPopup, setHoroIdProofPopup] = useState(false);
   const [idStatus, setIdstatus] = useState("N");
   const [horoStatus, setHorostatus] = useState("N");
   const [showHoroIdPopup, setShowHoroIdPopup] = useState(false);
   const [showTrustDocPopup, setShowTrustPopup] = useState(false);
   const [showCommonHoroPopup, setShowCommonHoroPopup] = useState(false);
   const [isMuslim, setisMuslims] = useState("N");
   const [showTrustSuccessPopup, setShowTrustSuccessPopup] = useState(false);
   const [showDoshaPopup, setShowDoshaPopup] = useState(false);
  //  const [showDoshamPopup, setShowDoshamPopup] = useState(false)
   const [dontshowtoaste, setDontShowtoaste] = useState(false);

   
   
  const isNotificationUpdated = useRef(false);
   const handleAddHoroscope = async () =>{
      // setHoroIdProofPopup(false); 
      if (!isNotificationUpdated.current) {
         const request = {
      "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      "userId": localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
      "isClicked": true,
      "clickButton": "Horoscope",
      "notificationId": ProfileData?.popup[0]?.notificationId,
    }
    Update_Notification_Status(request)
      // updateNotification();
      isNotificationUpdated.current = true;
    }
      setShowHoroIdPopup(true);       
    };

    const handleAddIdProof = async () =>{
      if (!isNotificationUpdated.current) {
      const request = {
      "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      "userId": localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
      "isClicked": true,
      "clickButton": "ID Proof",
      "notificationId": ProfileData?.popup[0]?.notificationId,
    }
    Update_Notification_Status(request)
      isNotificationUpdated.current = true;
    }
          apiCallEditProfile()
      setShowTrustPopup(true);
    };


   

  const { t: trans } = useTranslation();

  const { completeNow, clickAddHabits, setClickAddHabits,
    clickAddFamily, setClickAddFamily, clickAddAstro, setClickAddAstro,
    clickAddHoro, setClickAddHoro,showCLCnPopupotification, setShowCLCnPopupotification,hideCLCnotification,setHideCLCnotification } = useContext(NavBarContext);
  // Access the passed state
  const trailPackPopup = location.state?.trailPackPopup;

  const [starRaasiPopup, setStarRaasiPopup] = useState(false)
  const [showAddPhoto, setShowAddPhoto] = useState(false);
  const [showHoroPopup, setShowHoroPopup] = useState(false);
   const [passNotificationId, setPassNotificationId] = useState("N");

  
  const [successPopupData, setSuccessPopupData] = useState({ show: false, content: "" })
  const [showingSuccessPopup, setShowingSuccessPopup] = useState({ data: "", show: false })
  const [generatedHoroScopeUrl, setgeneratedHoroscopeurl] = useState({ url: "", flag: "", show: false });
  const [showingHoroPopup, setShowingHoroPopup] = useState({ data: "", show: false })

  const [showUploadSuccessPopup, setshowUploadSuccessPopup] = useState(false)
  const showSuccessPopup = (content) => {
    setSuccessPopupData({ show: true, content })
  }

  const closeSuccessPopup = () => {
    setSuccessPopupData({ show: false, content: "" })
  }

  const closeTrustSuccessPopup = () => {
    setShowTrustSuccessPopup(false);
  }

   const handleUploadComplete = () => {
    // setShowTrustDocPopup(false);
    setShowTrustSuccessPopup(true);
    setHoroIdProofPopup(true);
   addIdHorostatus();
  };

  useEffect(() => {
}, [showTrustSuccessPopup]);
  const { menuSelect, isPusherReceived, setIsPusherReceived, setCustomerTemplate ,showbottomtab,setShowBottomTab,setReminderPopups} = useContext(NavBarContext)


  const isCommunitySite = localStorage.getItem(Constants.loginLocalStorageKeys.isCommunitySite);
  const isV3User = localStorage.getItem("isV3User")


  const { ProfileData } = useSelector(state => ({
    ProfileData: state.DashBoardAPI?.ProfileData?.data
  }));

  const loggedInProfileStatus = ProfileData?.status

  let { communitySiteData } = useSelector(state => ({
    communitySiteData: state.Login?.communitySiteContent?.data
  }));

  // const callBackPopupFun = (data) => {
  //   setShowingSuccessPopup({ data: data, show: false })

  //   setgeneratedHoroscopeurl({ url: data, flag: "GenerateHoroscope", show: true });
  // }
const [showTrialPackPopup, setShowTrialPackPopup] = useState(false);
const [showclctoast, setShowclctoast] = useState(false);
const { customerChatClicked} = useContext(NavBarContext);

const addIdHorostatus = async () => {
  try {
    const email = localStorage.getItem(Constants.loginLocalStorageKeys.loginName);
    const userid = localStorage.getItem(Constants.loginLocalStorageKeys.loginId);
    let { data } = await axios.post(
      `${config.api.API_URL}${EndPoints.addIdHorostatusUrl()}`,
      { email, userid }
    );
    if (data?.status === "Success") {
      setIdstatus(data?.data?.idproofStatus);
      setHorostatus(data?.data?.horoscopeStatus);
      setisMuslims(data?.data?.Ismuslim);
       if(data?.data?.idproofStatus === "N" && data?.data?.horoscopeStatus === "N"){
                    setPassNotificationId("N");
                }
            else if(data?.data?.idproofStatus === "Y" && data?.data?.horoscopeStatus === "Y"){
              fetchReminderPopups();
              setDontShowtoaste(true);
            }
            else{
                    setPassNotificationId("Y");
                }
    } else {
      console.log("Error while fetching addIdHorostatus");
    }
  } catch (error) {
    console.log("Error while fetching addIdHorostatus", error);
  }
};

const [editMyProfielData, setEditMyProfielData] = useState('')
const [isEditProfileLoading, setIsEditProfileLoading] = useState(true);

 const apiCallEditProfile = async () => {
        // setIsEditProfileLoading(true);

        let request = {
            email: loginDetail()[0],
            userId: loginDetail()[1],
            loginFrom: localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
        };

        let { statusCode, data } = await POST(
            `${config.api.API_URL}${EndPoints.editMyProfileUrl()}`,
            request
        );

        if (statusCode === 200) {
            setEditMyProfielData(data?.data);
            // if (showHoroscope === true) {
            //     setgeneratedHoroscopeurl({ url: data?.data?.horoscope, flag: data?.data?.horoflag, show: true });
            // }
        } else if (statusCode === 401) {
            logout();
        }
        // setIsEditProfileLoading(false);

    };


useEffect(() => {
  if (HoroIdProofPopup) {
    addIdHorostatus();
  }
}, [HoroIdProofPopup]);

useEffect(() => {
  if(showTrustDocPopup){
        apiCallEditProfile()
        // dispatch(dashboardProfileData())
  }
    }, [])

    useEffect(() => {
  if (showingHoroPopup?.show) {
    addIdHorostatus();
    setHoroIdProofPopup(true);
  }
}, [showingHoroPopup?.show]);

  const callBackPopupFun = (data) => {

    setShowingSuccessPopup({ data: data, show: false });

    if (data && data.includes(".")) {
        const fileExtension = data.split(".").pop().toLowerCase();

        if (fileExtension === "pdf") {
            window.open(data, "_blank"); // Open PDF in a new tab
        } else {
            setgeneratedHoroscopeurl({ url: data, flag: "GenerateHoroscope", show: true });
        }
    } else {
        console.error("Invalid file format or missing extension.");
    }
};

  useEffect(() => {
    // Check if the condition is met and update the state
    if (ProfileData?.descriptionPopup?.[0]?.showpopup === "Description") {
      setShowDescriptionPopup(true);
    } else {
      setShowDescriptionPopup(false);
    }
  }, [ProfileData]);

 useEffect(() => {

  const isMatchesPage = location.pathname === RouteSegments.MATCH_LITE;
  const isTrialClosed = localStorage.getItem("trialPackPopupClosed") === "true";

  
  if (
    isMatchesPage &&
    Array.isArray(ProfileData?.trialPopup) &&
    ProfileData.trialPopup.length > 0 &&
    ProfileData.trialPopup[0]?.showpopup === "Trial_Pack_Expiry" &&
    !isTrialClosed
  ) {
    setShowTrialPackPopup(true);
  } else {
    setShowTrialPackPopup(false);
  }
}, [ProfileData, location.pathname]);

const handleTrialPackClose = () => {
  setShowTrialPackPopup(false);
  localStorage.setItem("trialPackPopupClosed", "true");
};


  useEffect(() => {


    const audio = new Audio(NotificationReceivedSound);
    // const channelName = `private-App.Models.User.1`;
    const channelName = `private-App.Models.User.${localStorage.getItem(
      Constants.loginLocalStorageKeys.chatLoginId,
    )}`;
    const customerCareChannelName = `private-user.${localStorage.getItem
      (Constants.loginLocalStorageKeys.chatLoginId,
      )}`;

    const pusher2 = new Pusher("kalyan123", {
      wsHost: config.messengerUrl,
      wsPort: "443",
      wssPort: "443",
      cluster: "ap2",
      authEndpoint: `${config.api.chat_api}/broadcasting/auth`,
      enabledTransports: ["ws", "wss"],
      // enabledTransports: ["ws"],
      encrypted: false,
      // disableStats: true,
      forceTLS: false,
      auth: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            Constants.loginLocalStorageKeys.chatLogin,
          )}`,
        },
      },
    });

    const channel = pusher2.subscribe(channelName);
    channel.bind(
      "Illuminate\\Notifications\\Events\\BroadcastNotificationCreated",
      (data) => {

        console.log(data,'pusherResponse');
        
       
        if (data.type === "App\\Notifications\\GroupChatMessage") {

          const sendId = Array.isArray(data?.message) ? data?.message[0].sender_id : data?.message?.sender_id


          if (!(sendId == getGroupAuthId())) {
            dispatch(groupMessageReceived(data.message));
            audio.play();
          }
          dispatch(getGroupChatList({ profileId: localStorage.getItem(Constants.loginLocalStorageKeys.profileId) }))
        } else if (data.type === "App\\Notifications\\ChatReaction") {

          if (!(data?.data?.reacted_by_id == getGroupAuthId())) {
            dispatch(reactionReceived(data))
          }

        } else if (data?.type === "App\\Notifications\\ChatReadStatus") {
          dispatch(readbyReceived(data.data))
        } else if (data?.type === "App\\Notifications\\SendPointsToUserEvent") {
          dispatch(pointAwarded())
        } else if (data?.type === "App\\Notifications\\SenderChatMessage") {
          // dispatch(messageReceived(data.message));
          dispatch(getChatList({
            page_size: Constants.matchRowCount,
            page: 1,
            isMessageFrom: "pushNotification"
          }))
          dispatch(
            getConversationList({
              receiver_id: data?.message?.receiver_profile_id,
              receiver_status: loggedInProfileStatus,
              isMessageFrom: "pushNotification"
            }),
          );
        }
        else {
          setIsPusherReceived(true)
          dispatch(messageReceived(data.message));
          dispatch(getChatList({
            page_size: Constants.matchRowCount,
            page: 1,
          }))
        
          dispatch(UnreadMsgCount({
            sender_id: localStorage.getItem(Constants.loginLocalStorageKeys.loginId)
          }))
          //   dispatch(ResetUnReadCount({
          //   conversation_id: localStorage.getItem(Constants.loginLocalStorageKeys.conversationId),
          //   sender_id: localStorage.getItem(Constants.loginLocalStorageKeys.loginId)
          // }));
          if (data?.message?.is_fulfillment_processed) {
            setTimeout(() => {
              dispatch(
                getProfileMatch({
                  email: loginDetail()[0],
                  userId: loginDetail()[1],
                  viewprofileid: data?.message?.sender_profile_id,
                  status: "new",
                  callFrom: "MatchPopup",
                  loginFrom: getDeviceInfo(),
                  pageno: 1,
                }, logout),
              );
            }, 2000);
          }

          if (!data.is_muted) {
            audio.play();
          }
        }

      },
    );

    channel.bind("App\\Notifications\\ChatReaction", (data) => {
    })


    // Customer care channel subscription
    const customerCareChannel = pusher2.subscribe(customerCareChannelName);
    customerCareChannel.bind("pusher:subscription_succeeded", () => {
    });

    customerCareChannel.bind("App\\Events\\SendMessageToCustomerEvent", (data) => {
      localStorage.setItem(Constants.loginLocalStorageKeys.messageId, data?.message?.id)
      localStorage.setItem(Constants.loginLocalStorageKeys.admUserId, data?.message?.adm_users_id)
      localStorage.setItem(Constants.loginLocalStorageKeys.conversationId, data?.message?.conversation_id)
      dispatch(UnreadMsgCount({
        sender_id: localStorage.getItem(Constants.loginLocalStorageKeys.loginId)
      }));
      audio.play().catch(e => console.error("Audio play error:", e));
      // dispatch(
      //   getCustomerServiceConversation({
      //     sender_id: localStorage.getItem(Constants.loginLocalStorageKeys.loginId)
      //   }),
      // );
      if (data?.message?.message_type_id == 6) {
        setShowRankingPopup(true)
        setCustomerTemplate(false)

      }
      if (localStorage.getItem(Constants.loginLocalStorageKeys.customerChatClicked) === "true") {
        dispatch(
          getCustomerServiceConversation({
            sender_id: localStorage.getItem(Constants.loginLocalStorageKeys.loginId)
          }),
        );
      }
      if (data?.message?.message_type_id == 6) {
        setShowRankingPopup(true)
      }
    });

    const showActivityFeedback = (data) => {
      dispatch(pointAwarded(data))
    }

    customerCareChannel.bind("App\\Events\\SendPointsToUserEvent", (data) => {
      if (data?.activityId == 1) {
        showActivityFeedback(data)
      }
    });

    customerCareChannel.bind("App\\Events\\UserPointEvent", (data) => {
      if (data?.activityId > 1) {
        showActivityFeedback(data)
      
      }
    });


    return () => {
      pusher2.disconnect();
    };
  }, []);

  useEffect(() => {
    dispatch(dashboardProfileData({}, logout));
    // dispatch(getActivityTotalPoints())
    if (localStorage.getItem("checkbox")) {
      if ((localStorage.getItem("LOGIN_FROM") == "/new/matches" || localStorage.getItem("LOGIN_FROM") == "/")) {
        if (sessionStorage.getItem("functionCalled") == null) {

          let name = localStorage.getItem(Constants.loginLocalStorageKeys.loginName) || localStorage.getItem(Constants.loginLocalStorageKeys.loginPhone);
          let password = localStorage.getItem("pw");

          if(!localStorage.getItem(Constants.loginLocalStorageKeys.familyLoginMobileNumber)){
            dispatch(loginUser({ name, password }, navigate));}

          sessionStorage.setItem("functionCalled", "true");
        }
      } 
    }
  }, []);

  const updateDeviceToken = async (token) => {
    try {
      const request = {
        "webKey" : token
      };

      const { statusCode, data } = await POST(
        `${config.api.API_URL}${EndPoints.UpdateDeviceTokenUrl()}`,
        request
      );


      if (statusCode === 200) {
        if (data.data.status === "SUCCESS") {
        }

      } else if (statusCode === 401) {
        logout();
      }
    } catch (error) {
      console.error("Error fetching update device token data:", error);
    }
  };

  async function requestPermission() {
    //requesting permission using Notification API
    const permission = await window.Notification.requestPermission();

    if (permission === "granted") {
      window.navigator.serviceWorker.register(process.env.PUBLIC_URL + '/firebase-messaging-sw.js', { scope: "/firebase-cloud-messaging-push-scope" }).then(async () => {
        const token = await getToken(messaging, {
          vapidKey: "BOkYKLBpw9iIkK7p3rSiRiOUvvaTj77ZBIueLdsSRy9BeiragVXvww6zR1IawhNGDhJjsxB0JolYTzBwqapVGyI",
        });

        localStorage.setItem(Constants.loginLocalStorageKeys.fcmToken, token)
        updateDeviceToken(token)
        localStorage.setItem(Constants.loginLocalStorageKeys.showNotifyPopup,"true")
      })
      //We can send token to server
    } else if (permission === "denied") {
      localStorage.setItem(Constants.loginLocalStorageKeys.showNotifyPopup,"true")
      //notifications are blocked
      // alert("You denied for the notification");
    }
  }

  useEffect(() => {
    if("Notification" in window){
      if (window.Notification.permission !== "granted" &&  localStorage.getItem(Constants.loginLocalStorageKeys.showNotifyPopup) != "true") {
        setShowNotificationPermission(true)
      }else{
        // requestPermission()
      }

    }

  }, []);



  const closePermission = () => {
    requestPermission()
    setShowNotificationPermission(false)
    localStorage.setItem(Constants.loginLocalStorageKeys.showNotifyPopup,"true")
  }


  const fetchGroupData = async () => {
    const profileId = ProfileData?.profileId;
    if (!profileId) {
      // Handle the case when profileId is not available
      console.error('ProfileId not available');
      return;
    }

    const { statusCode, data } = await GET(
      `${config.api.API_URL}${EndPoints.getfamilyUrl(profileId)}`
    );


    if (statusCode === 200) {
      if (data.status === 'Success') {
        if (data.data.groupMembers?.length > 0) {
          const relation = data.data.groupMembers?.filter(member => member?.parentsMobileNumber == localStorage.getItem(Constants.loginLocalStorageKeys.familyLoginMobileNumber))
          if (relation[0]?.relationshipName) {
            localStorage.setItem(Constants.loginLocalStorageKeys.familyLoginRelation, relation[0]?.relationshipName)
          }
        }
      }
    }
  }

  useEffect(() => {

    if (ProfileData) {
      fetchGroupData()
      localStorage.setItem(Constants.loginLocalStorageKeys.profileId, ProfileData?.profileId)
      localStorage.setItem(Constants.loginLocalStorageKeys.loginUserStatus, ProfileData?.status)
      localStorage.setItem(Constants.loginLocalStorageKeys.loginEmail, ProfileData?.usermailid ?? "")
      localStorage.setItem(Constants.loginLocalStorageKeys.loginUserName, ProfileData?.username)
      localStorage.setItem(Constants.loginLocalStorageKeys.loginPhone, ProfileData?.userphoneno)
      localStorage.setItem(Constants.loginLocalStorageKeys.loginCountryCode, ProfileData?.usercountrycode)
      localStorage.setItem(Constants.loginLocalStorageKeys.loginPhone, ProfileData?.userphoneno)
    }
  }, [ProfileData])



  const {
   
    initialMatchDataPopup
    
  } = useSelector(MatchSelector.getRecommendedMatches)

  const  ShowpopupData = initialMatchDataPopup?.currentMatch?.matchdata?.popup[0]?.showpopup


  
  useEffect(() => {

   
    if (initialref.current) return


     if(localStorage.getItem("notifyId") == 'true'){
              localStorage.getItem("notifyId")
            }else {
              localStorage.removeItem("notifyId" );
              localStorage.setItem("notifyId" , 'false')
            }
            
    if (ProfileData?.popup?.length > 0) {

      if (ProfileData?.popup[0]?.showpopup == 'upgrade' || ProfileData?.popup[0]?.showpopup == 'photo' || ProfileData?.popup[0]?.showpopup == 'paymentpagevisited') {
        setPopupOpen(false)
        setPhotoPopupOpen(false)
        setPhotoNewPopupOpen(false)
      }
      else {
        if (ProfileData?.popup[0]?.showpopup) {
          initialref.current = true
          setPopupContent(ProfileData?.popup[0]?.showpopup == 'PrivacyOption' ? trans('clcprivacy_popup.add_photo_to_your_profile_and') :
            ProfileData?.popup[0]?.showpopup == 'StarRaasi' ? "Profiles with Star & Raasi gets more responses. Add Star & Raasi details to your profile based on our recommendation or add your own. Add Star & Raasi Now!" :
              ProfileData?.popup[0]?.content)
          setNotificationId(ProfileData?.popup[0]?.notificationId)
          const src = Icons[ProfileData?.popup[0]?.showpopup]
          setImageSrc(src);
          
          setButtonName(trans(commonPopupButtonNames[ProfileData?.popup[0]?.showpopup]))
          setTitle(trans(commonPopupTitleNames[ProfileData?.popup[0]?.showpopup]))
          // setPopupContent('Add photo to your profile and take control of your privacy by using privacy options.')
          //   setNotificationId(ProfileData?.popup[0]?.notificationId)
          //   const src= Icons['PrivacyOption']
          //   setImageSrc(src);
          //   setButtonName(commonPopupButtonNames['PrivacyOption'])
          //   setTitle(commonPopupTitleNames['PrivacyOption'])
          if (isCommunitySite && ProfileData?.popup[0]?.showpopup == 'DownloadApp') {
            setPopupOpen(false)
          } 
          else if (ProfileData?.popup[0]?.showpopup == "TrialPack" || localStorage.getItem("popupFromApp")) {
            setShowTrailPackPopup(true)
            localStorage.removeItem("notifyId");
            if(localStorage.getItem("popupFromApp")){
              localStorage.removeItem("popupFromApp");
              localStorage.setItem("AppPopup",true);
            }
            localStorage.removeItem("notifyId" );
          }
          else if(trailPackPopup == 'Y'){
            setShowTrailPackPopup(true)
            if(localStorage.getItem("notifyId") == 'true'){
              localStorage.getItem("notifyId")
            }else {
              localStorage.removeItem("notifyId" );
              localStorage.setItem("notifyId" , 'false')
            }
            
          }

          else if (ProfileData?.popup[0]?.showpopup == "AddPhoto"){
            
            setPopupOpen(false)
            setPhotoNewPopupOpen(true)
          }else if(ProfileData?.popup[0]?.showpopup =="Photo Preview"){
            setClcAddPhotoPopup(true)
          }

          else if (ProfileData?.popup[0]?.showpopup == "AddParentsNumber" || ProfileData?.popup[0]?.showpopup == "AddParentsNumber_2"){
            setPopupOpen(false)
            setShowParentNumPopup(true)
          }
          else if(ProfileData?.popup[0]?.showpopup =="Payment Popup"){
            setShowPaymentPopup(true)
          }
          else if (ProfileData?.popup[0]?.showpopup === "PaymentPush") {
            if (ProfileData?.popup[0]?.popup_type === "Big Pop-up") {
              setPaymentCLCbigPopup(true);
            } else {
              setPaymentCLCsmallPopup(true);
            }
          }else if( ProfileData?.popup[0]?.showpopup == "AddIDProofHoroscope"){
              setHoroIdProofPopup(true);
          }
          else if(ProfileData?.popup[0]?.showpopup == "RejectedProfile"){
           navigate(`${RoutePaths.EDITPROFILE_LITE}/my-profile`);
          }
          
          else {
            setPopupOpen(true)
            // setPhotoPopupOpen(true)
          }
        }
      }
    }
    

  }, [ProfileData])


  //check if family code is not setted, then show family code popup
  useEffect(() => {
    if (ProfileData?.familycode == "Y") {
      setShowFamilyCodePopup(true)
    }
  }, [ProfileData])

  //show kalyan rewards popup after 3min
  useEffect(() => {
    if (ProfileData?.showactivitypopup == "Y") {
      setTimeout(() => {
        setShowRewardsPopup(true)
      }, Constants.kalyanRewardsPopupWaitTime);
    }
  }, [ProfileData])

  useEffect(()=>{
    if(customerChatClicked){
      setShowclctoast(false);
      setShowCLCnPopupotification(false);
    }
  },[customerChatClicked])

  const onPopupClose = async (data, param) => {
    if (param != "notification") {
      setPopupOpen(false)
    }
    const request = {
      "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      "userId": localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
      "isClicked": data,
      "clickButton": param == "addPhoto" ? "photo" : param == "viewMatches" ? "view matches" : param=="AddPhotoPreview" ?"PhotoPreview" : undefined,
      "notificationId": localStorage.getItem("notificationId") ? localStorage.getItem("notificationId") : notificationId ?? location?.state?.data?.notificationId,
    }
    
    Update_Notification_Status(request);

    if (!data) {
          setShowCLCnPopupotification(true);
      sessionStorage.removeItem(Constants.loginLocalStorageKeys.notificationId, notificationId)
    }

  }

  const onTrialPackExpiryPopupClose = (data,param) => {
    if (param == "trialpackexpiry") {
      const request = {
      "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      "userId": localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
      "isClicked": data,
      "clickButton": param == "addPhoto" ? "photo" : param == "viewMatches" ? "view matches" : param=="AddPhotoPreview" ?"PhotoPreview" : undefined,
      "notificationId": localStorage.getItem("notificationId") ? localStorage.getItem("event_clc_track_id") : notificationId ?? location?.state?.data?.notificationId,
    }

    Update_Notification_Status(request);
  }
};

  const redirectTo = ({ path, notiId, notiContent }) => {
    if (path == 'DownloadApp') {
      window.open(RouteSegments.staticLinkForAppDownload.android)
      return;
    }
       sessionStorage.setItem(Constants.loginLocalStorageKeys.notificationId, notiId)

    if (path == 'photo' ) {
      setFrom(path);
      setShowAddPhoto(true)
    }
  
    if ( path == "AddPhotoFromCLC") {

      setFrom(path);

      setShowAddPhoto(true)
      navigate(RouteSegments.MATCH_LITE, { replace: true })
    }
    else if (path == 'PartnerPreference') {
      navigate(RouteHelper.getEditProfileUrl(EditProfileMenu[1].urlPath), {
        state: { isFromInitialPopup: true },
      });
    } else if (path == 'Matches') {

    } else if (path == "StartMessage") {
      navigate(RouteSegments.MATCH_CONVERSATIONS_LITE, { state: { from: "newConversations", isFromChat: true } })
    } else if (path == 'NewMatches') {
      localStorage.setItem("isfromkmreminder",true);
      partnerPrefSearchApi()
    } else if (path == "AddParentsNumber" || path == "AddParentsNumber_2") {
      setNotificationId(notiId)
      setPopupContent(notiContent)
      setFrom(path);
      setPopupOpen(false)
      setShowParentNumPopup(true)
    } else if (path == "ReadAndReply"
      || path == "UnreadMessage"
      || path == "MsgSeenNotReply") {
      navigate(RouteSegments.CHAT_LITE, {
        state: { isFromInitialPopup: true },
      });
    }
    else if (path == "viewMatches") {
      localStorage.setItem("isfromkmreminder",true);
      let list = FilterOptions.filter(data => data.id == 8).map(data => ({ ...data, getRequest: null, isChecked: true }))
      sessionStorage.setItem(Constants.loginLocalStorageKeys.filterState, JSON.stringify({ isFrom: "clcpopup", selectedFilter: list }))
      navigate(RouteSegments.MATCH_LITE, { state: { isFrom: "clcpopup", selectedFilter: list } })

    }
    else if (path == "TrialPack") {
      setShowTrailPackPopup(true)
      navigate(RouteSegments.MATCH_LITE, { replace: true })
    } else if (path == 'PrivacyOption') {
      // setShowAddPhoto(true)
      setPrivacyPhotoPopupOpen(true)
      // navigate(RouteSegments.MATCH_LITE, { replace: true })
    }
    else if (path == "viewMatches") {

      let list = FilterOptions.filter(data => data.id == 8).map(data => ({ ...data, getRequest: null, isChecked: true }))
      sessionStorage.setItem(Constants.loginLocalStorageKeys.filterState, JSON.stringify({ isFrom: "clcpopup", selectedFilter: list }))
      navigate(RouteSegments.MATCH_LITE, { state: { isFrom: "clcpopup", selectedFilter: list } })

    } else if (path == "WhoViewedMyprofile") {
      setPopupOpen(true)
      navigate(RouteSegments.MATCH_GROUP, { replace: true })
    }
    else if (path == "StarRaasi") {
      setPopupOpen(false)
      setStarRaasiPopup(true)

      navigate(RouteSegments.MATCH_LITE, { replace: true })
    }
    else if (path == "Horoscope") {
      setShowHoroPopup(true)
      navigate(RouteSegments.MATCH_LITE, { replace: true })
    }
  else if(path=="PhotoPreview" || path=="Photo Preview"){
    setClcAddPhotoPopup(true)
    navigate(RouteSegments.MATCH_LITE, { replace: true })

  }else if (path == 'AddPhoto'&& searchParams.get("photo")== "Y") {
    // setPhotoPopupOpen(true)
    setPhotoNewPopupOpen(true)
    navigate(RouteSegments.MATCH_LITE, { replace: true })
  }
  else if (path == 'AddPhoto') {
    // setPhotoPopupOpen(true)
    setPhotoNewPopupOpen(true)
    navigate(RouteSegments.MATCH_LITE, { replace: true })
  }
  // else if (path=="photorejected"){
  //   navigate(RouteSegments.editProfileTab(3))
  //   setShowPhoto(true)
  // }
  else if(path=="photoapproved" || path=="myPhotosPage"){
    navigate(RouteSegments.PROFILE_PREVIEW , { replace: true })
  }
  }



  useEffect(() => {
    if (ProfileData) {
      // setShowReligiousMigrationPopup(ProfileData?.showcastemigration === "Y");
      setShowCastePopup(ProfileData?.cleanClearExecution === true)
    }
  }, [ProfileData]);

   useEffect(() => {
    if (ProfileData?.doshamPopup == "Y") {
      // setShowReligiousMigrationPopup(ProfileData?.showcastemigration === "Y");
      setShowDoshaPopup(true);
    }
  }, [ProfileData?.doshamPopup]);

  useEffect(() => {
    //CLC
    const path = searchParams.get("path") || searchParams.get("redirection")
    const notiId = searchParams.get("notificationId")
    const notiContent = searchParams.get("notificationContent")
    const loginUrl = sessionStorage.getItem(Constants.loginLocalStorageKeys.loginUrl);


    if (path && notiId) {
      searchParams.delete("path")
      searchParams.delete("notificationId")
      searchParams.delete("isNew")
      searchParams.delete("notificationContent")
      sessionStorage.setItem(Constants.loginLocalStorageKeys.notificationPath, path)
      setSearchParams(searchParams, { replace: true })
      onPopupClose(true);
      redirectTo({
        path,
        notiId,
        notiContent
      })
    } else if (loginUrl?.includes("pp_matches") || searchParams.get("pp_matches") == "Y") {
      partnerPrefSearchApi()
    } else if (searchParams.get("WhoViewedMyprofile") == "Y" && location?.state?.isFrom == "chromenotif") {
      // searchParams.delete("WhoViewedMyprofile")
      // setSearchParams(searchParams, { replace: true })
      onPopupClose(true, "notification");
      setPopupContent(location?.state?.data?.notificationContent ?? "")
      setNotificationId(location?.state?.data?.notificationId)
      setImageSrc(Images.EyeIcon);
      setButtonName("WhoViewedMyprofile")
      setTitle("Add Photo & View Matches")
      setPopupOpen(true)
      setPhotoPopupOpen(true)
    }
    else if(searchParams.get("photo") ){
      setShowAddPhoto(true)
    }
    else if ((searchParams.get("PhotoPreview")  || location?.state?.isFrom=="photopreview") 
      || (searchParams.get("PhotoPreview") =="Y"&& location?.state?.isFrom=="photopreview") || searchParams.get("Photo Preview")){
      setClcAddPhotoPopup(true)
    }
    else if(searchParams.get("photo") == "Y" ){
      setShowAddPhoto(true)
     
    }
    else if((searchParams.get("AddPhoto") && searchParams.get("photo")== "Y") || location?.state?.data?.isFrom=="Addphoto" || searchParams.get("AddPhoto")){
      // setPhotoPopupOpen(true)
      setPhotoNewPopupOpen(true)
    }
  }, [searchParams])



  useEffect(() => {

    if (ProfileData) {
      if (searchParams.get("WhoViewedMyprofile") == "Y") {
        if (ProfileData?.imageState != "A") {
          setPopupContent(location?.state?.data?.notificationContent)
          setNotificationId(location?.state?.data?.notificationId)
          setImageSrc(Images.EyeIcon);
          setButtonName("WhoViewedMyprofile")
          setTitle("Add Photo & View Matches")
          setPopupOpen(true)
          setPhotoPopupOpen(true)
          // setClcAddPhotoPopup(true)
        }

      }
    }
    else if(searchParams.get("photo") == "Y"){
      setShowAddPhoto(true)
     
    }
    else if(searchParams.get("PhotoPreview") || searchParams.get("PhotoPreview")=="Y" || searchParams.get("Photo Preview")){
      setClcAddPhotoPopup(true)
     
    } else if(searchParams.get("AddPhoto") && searchParams.get("photo") == "Y" || searchParams.get("AddPhoto")){
      setPhotoNewPopupOpen(true)
      // setPhotoPopupOpen(true)
    }



  }, [searchParams, ProfileData])


  
  const isFroms = location?.state?.data?.isFrom || location?.state?.isFrom; // Try both
  

  useEffect(() => {

    if (location?.state?.isFrom == "listnotification") {
      onPopupClose(true, "notification");
      setPopupContent(location?.state?.data?.notificationContent)
      setNotificationId(location?.state?.data?.notificationId)
      setImageSrc(Images.EyeIcon);
      setButtonName("WhoViewedMyprofile")
      setTitle("Add Photo & View Matches")
      setPopupOpen(true)
      // setPhotoPopupOpen(true)
    }
    if(isFroms=="photopreview"){
      setClcAddPhotoPopup(true)
    }

  

    if(isFroms=="Addphoto"){
      setPhotoNewPopupOpen(true)
      // setPhotoPopupOpen(true)
    }

  }, [location])

//preload image
  useEffect(() => {
    const img = new Image();
    img.src = Images.paymentpopupicon;
  }, []);

  useEffect(()=>{
    
    setShowBottomTab(false)
  },[])

  useEffect(() => {
    localStorage.setItem("previousPage", location.pathname);
  }, [location]);


  const partnerPrefSearchApi = async () => {
    let request = {
      email: loginDetail()[0] ?? null,
      userId: loginDetail()[1],
    };

    let { statusCode, data } = await POST(
      `${config.api.API_URL}${EndPoints.partnerpreferencesearch()}`,
      request
    );

    if (statusCode === 200) {

      const locState = {
        isFrom: "basicAdvanceSearch",
        menu: "savepreferences",
        searchTerms: data?.data,
        ppedited: false,
        isBasicSearch: false,
        loading: true
      }
      sessionStorage.setItem(Constants.loginLocalStorageKeys.filterState, JSON.stringify(locState))
      navigate(RouteSegments.MATCH_LITE, {
        state: locState,
        replace: true,
      });


    } else if (statusCode === 401) {
      logout();
    }
  }


  const NotifyId = sessionStorage.getItem(Constants.loginLocalStorageKeys.notificationId)

  const notification = ProfileData?.popup[0]?.notificationId

  
  const onPopupBtnClick = (param) => { 
    
    onPopupClose(true, param);
    redirectTo({
      path: param == "addPhoto" ? "AddPhotoFromCLC" : param == "viewMatches" ? "viewMatches" 
      : param =="AddPhoto"?"CLC_AddPhoto":  param =="AddWhatsapp" || param=="addwhatsapppreview"?"CLC_Whatsapp"
      : param=="PhotoPreview"? "CLC_Gallery":param=="addcamarapreview"? "CLC_Camera":
      param =="Addfacebook"?"CLC_Facebook": ProfileData?.popup[0]?.showpopup,
      notiId:  notification  ? notification : NotifyId
    });
  }

  const onRewardsPopupClose = () => {
    setShowRewardsPopup(false)
  }

  const closePhotoPopup = () => {
    setShowAddPhoto(false)
    setShowPhoto(false)
  }

  const buttonClick = () => {
    let list = FilterOptions.filter(data => data.id == 8).map(data => ({ ...data, getRequest: null, isChecked: true }))
    sessionStorage.setItem(Constants.loginLocalStorageKeys.filterState, JSON.stringify({ isFrom: "clcpopup", selectedFilter: list }))
    navigate(RouteSegments.MATCH_LITE, { state: { isFrom: "clcpopup", selectedFilter: list } })
    setSuccessPopup(false);
  }



  const onPhotoPopupClose = async (data ,param) => {
    const request = {
      "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      "userId": localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
      "isClicked": data,
      "notificationId": NotifyId ? NotifyId :notificationId ,
      "clickButton" : param =="AddPhoto" ? "CLC_AddPhoto":param =="Addfacebook"?"CLC_Facebook": param =="AddWhatsapp" || param=="addwhatsapppreview" ?"CLC_Whatsapp": 
      param=="PhotoPreview"? "CLC_Gallery":param=="addcamarapreview"? "CLC_Camera":""
    }
    Update_Notification_Status(request);

    if (!data) {
      sessionStorage.removeItem(Constants.loginLocalStorageKeys.notificationId, notificationId)
    }

  }
 


  const onPayNow = ()=>{
    setShowPaymentPopup(false)
    const request = {
      "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      "userId": localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
      "isClicked": true,
      "subject": "Payment Popup",
      "notificationId": ProfileData?.popup[0]?.notificationId,
    }
    Update_Notification_Status(request)
    onClickTrack(EventName.ECLC_Popup_Payment_Popup_Pay_Now_Button);
    localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage,RouteSegments.PAYMENT_PAGE)
    ProfileData.popup[0].showpopup = "";
    navigate(RouteSegments.PAYMENT_PAGE, { state: { isFrom: "clcpopup",notificationId:ProfileData?.popup[0]?.notificationId } })
  }

  const onPaynowCancel = ()=>{
    setShowPaymentPopup(false)
    onClickTrack(EventName.ECLC_Popup_Payment_Popup_Cancel_Button);
    // const request = {
    //   "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
    //   "userId": localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
    //   "isClicked": false,
    //   "subject": "Payment Popup",
    //   "notificationId": ProfileData?.popup[0]?.notificationId,
    // }
    // Update_Notification_Status(request)
  }

//   useEffect(() => {
//   if (ProfileData?.popup[0]?.showpopup === "PaymentPush") {
//     if (ProfileData?.popup[0]?.popup_type === "Big Pop-up") {
//       setPaymentCLCbigPopup(true);
//     } else {
//       setPaymentCLCsmallPopup(true);
//     }
//   }
// }, [ProfileData]);


 const onPayNowPage = ()=>{
    setPaymentCLCsmallPopup(false)
    setPaymentCLCbigPopup(false)
    const request = {
      "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      "userId": localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
      "isClicked": true,
      // "subject": "Payment Popup",
      "clickButton": ProfileData?.popup[0]?.popup_type === "Big Pop-up" ? "Buy a Pack and Call Now!" : "Know more",
      // "clickButton": "Big Pop-up",
      "notificationId": ProfileData?.popup[0]?.notificationId,
      //  "notificationId":1,
    }
    Update_Notification_Status(request)
    if(ProfileData?.popup[0]?.popup_type == "Big Pop-up"){
    onClickTrack(EventName.V3_Site_Payment_CLC_Popup_Buy_a_Pack_and_Call_Now_Button);
    }else{
    onClickTrack(EventName.V3_Site_Payment_CLC_Popup_Know_more_Button);
    }
    localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage,RouteSegments.MEMBERSHIP_REGISTER)
    ProfileData.popup[0].showpopup = "";
    // navigate(RouteSegments.MEMBERSHIP_REGISTER, { state: { isFrom: "clcpopup",notificationId:ProfileData?.popup[0]?.notificationId } })
    localStorage.setItem("clcpopup", true);
     localStorage.setItem("clcpopupnotificationId",  ProfileData?.popup[0]?.notificationId);
     localStorage.setItem("fromPage","Payment CLC");
    navigate(RouteSegments.MEMBERSHIP_REGISTER(), {
  state: {
    isFrom: "clcpopup",
    notificationId:  ProfileData?.popup[0]?.notificationId
    // notificationId: 1
  }
});
  }


  useEffect(() => {
    if (uploadPhotoSuccessPopup || successPopup || showUploadSuccessPopup) {
      fetchReminderPopups();
      setShowclctoast(false);
      setShowCLCnPopupotification(false);
    }
  }, [uploadPhotoSuccessPopup,showingSuccessPopup?.show,successPopup,showUploadSuccessPopup]);
  
  const fetchReminderPopups = async () => {
    try {
      const request = {
        email: loginDetail()[0],
        userId: loginDetail()[1],
        loginFrom: localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
      };
      const response = await POST(
        `${config.api.API_URL}${EndPoints.kmcareReminderSystemUrl()}`,
        request
      );
  
      if (response?.data?.status === "Success") {
        setReminderPopups (response?.data?.data?.popup || []);
      } else if (response?.data?.statusCode === 401) {
        logout();
      }
    } catch (err) {
      setReminderPopups ([]);
    }
  };

  // SHOW KALYAN TOASTE NOTIFICATION
useEffect(() => {
  setShowclctoast(showCLCnPopupotification);
}, [showCLCnPopupotification]);

const [bgColor, setBgColor] = useState("bg-[#F0F2F5]"); // Default to white background

useEffect(() => {
  // Define the onload logic
  window.onload = function () {
    console.log("Window has loaded");
    setBgColor("bg-[#F0F2F5]"); // Set background color to white on load
  };

  // Change the background color to red after the page has loaded
  const timer = setTimeout(() => {
    setBgColor("bg-[#d10a11]"); // Change to red background
  }, 2000); // Delay of 2 seconds (adjust as needed)

  // Cleanup the onload event and timer when the component unmounts
  return () => {
    window.onload = null;
    clearTimeout(timer);
  };
}, []);

  return (
    <div>
      {
        showTrialPackPopup  ?
          <TrialPackExpiryPopup
            onClose={handleTrialPackClose}
            validTo={ProfileData.trialPopup[0]?.validTo}
            eventClcTrackId={ProfileData.trialPopup[0]?.event_clc_track_id}
          />
        : <></>
      }
      {!showTrialPackPopup && 
      
      <>
      {showclctoast && 
        <KalyanToast 
        onClose={() => {
          onClickTrack(EventName.V3_Site_KMCare_Notification_Alert_Close_Button);
          // setShowclctoast(false);
          setShowCLCnPopupotification(false);

        }}
        onDismiss={() => {
          // setShowclctoast(false);
          setShowCLCnPopupotification(false);

        }}
        
        />      
        }
     {showRankingPopup &&
        <RankingStartPopup
          close={() => setShowRankingPopup(false)}
        />}

      {
        successPopup && (
          <CommonSuccessPopup
            close={() => {
              setSuccessPopup(false);
            }}
            title={"Photo Uploaded Successfully"}
            content={""}
            from={from}
            buttonClick={buttonClick}
          />
        )
      }
      {starRaasiPopup &&
        <AstroPopup OnClose={() => setStarRaasiPopup(false)} />}


      {/* 
      {
        showAddPhoto && <UploadPhotoPopuplite
          close={closePhotoPopup}
          title={"Add Photo"}
          callBack={() => {
            showSuccessPopup("Image uploaded succesfully")
          }}
          isFrom={"contentcard"}
          callBackReload={() => { }}
          setshowUploadSuccessPopup={setshowUploadSuccessPopup}
          PrivacyOptionTitle={commonPopupTitleNames[ProfileData?.popup[0]?.showpopup]}
        />
      } */}

      {
        showAddPhoto && showPhoto&& <UploadPhotoPopuplite
          close={closePhotoPopup}
          title={trans('photo_popup.add_photo')}
          callBack={() => {
            showSuccessPopup("Image uploaded succesfully")
          }}
          setUploadPhotoSuccessPopup={ setUploadPhotoSuccessPopup}
          isFrom={"contentcard"}
          callBackReload={() => { }}
          
          from={from}
          clcClick={() => {
            if (from == "AddPhotoFromCLC") {
              setSuccessPopup(true);
            }
          }}
        />
      }
      {
        showRewardsPopup && createPortal(
          <KalyanRewardsPopup close={onRewardsPopupClose} />,
          document.body
        )
      }
      {
        showAddPhoto && <UploadPhotoPopuplite
          close={closePhotoPopup}
          title={trans('photo_popup.add_photo')}
          callBack={() => {
            showSuccessPopup("Image uploaded succesfully")
          }}
          setUploadPhotoSuccessPopup={ setUploadPhotoSuccessPopup}
          isFrom={"contentcard"}
          callBackReload={() => { }}
          from={from}
          clcClick={() => {
            if (from == "AddPhotoFromCLC") {
              setSuccessPopup(true);
            }
          }}
          // setshowUploadSuccessPopup={setshowUploadSuccessPopup}
          PrivacyOptionTitle={trans(commonPopupTitleNames[ProfileData?.popup[0]?.showpopup]) ? trans(commonPopupTitleNames[ProfileData?.popup[0]?.showpopup]) : trans('clcprivacy_popup.add_photo_with_privacy_options')}
        />
      }
      {
        showUploadSuccessPopup && (
          <CommonUploadSuccessfull close={() => setshowUploadSuccessPopup(false)} notificationId={ProfileData?.popup[0]?.notificationId} />
        )
      }

      {
        showHoroPopup &&
        <CommonHoroPopup 
          isFrom={"clcRedirection"} 
          setShowingSuccessPopup={setShowingSuccessPopup} 
          notifyId={notificationId} 
          OnClose={(type,isFrom) => { 
            if(type == "upload_via"){
              setshowUploadHoroscope(true);
              setIsFrom(isFrom)
            }
            setShowHoroPopup(false)
          }}
        /> 
      }
      {
        showUploadHoroscope &&
        <UploadHoroscopeViaPopup
          close={() => setshowUploadHoroscope(false)}
          setShowingSuccessPopup={setShowingSuccessPopup}
          isFrom={isFrom} 
        />
      }

      {
        showingSuccessPopup?.show &&
         <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
        <CommonSuccessPopup
          close={() => {
            setShowingSuccessPopup((prev => ({ ...prev, show: false })));
          }}
          // title={trans('photos.success')}
          isFrom={"clcRedirection"}
          content={HoroIdProofPopup ? trans('my_profile.horoscope_uploaded_successfull') : "Horoscope Added Successfully"}
          buttonName={HoroIdProofPopup ? '' : trans('chat.view_horoscope')}
          callBackPopupFun={() => callBackPopupFun(showingSuccessPopup?.data)}
        />
        </div>
      }

      {
        generatedHoroScopeUrl.show ? (
          <ImageHoroscopePopup
            close={() => setgeneratedHoroscopeurl(prev => ({ ...prev, show: false }))}
            title={trans('chat.view_horoscope')}
            deleteImage={true}
            isShowEditBtn={false}
          >
            {generatedHoroScopeUrl.flag === "GenerateHoroscope" ? (
              <div className="relative">
                <iframe
                  title={trans('view_profile.horoscope')}
                  src={generatedHoroScopeUrl.url}
                  className="w-[70vw] lg:w-[60vw] h-[50vh]"
                />
                {/* {showHoroScopeLoader === true? <div className="absolute transform -translate-x-1/2 -translate-y-1/2 maxabsolute top-1/2 left-1/2"><Loader /></div>:null} */}
              </div>
            ) : (
              <img
                alt=""
                src={generatedHoroScopeUrl.url}
                className="w-[70vw] lg:w-[60vw] h-[50vh]"
              />
            )}
          </ImageHoroscopePopup>
        ) : (
          <></>
        )
      }

      {
        showRewardsPopup && createPortal(
          <KalyanRewardsPopup close={onRewardsPopupClose} />,
          document.body
        )
      }
      {/* {showFamilyCodePopup &&
        <FamilyCodePopup close={()=>setShowFamilyCodePopup(false)} />
      } */}

     

      {
        ProfileData?.popup[0]?.showpopup == "TrialPack"   ||  ProfileData?.popup[0]?.showpopup == "AddPhoto" ||  ProfileData?.popup[0]?.showpopup == "Photo Preview" ||  ProfileData?.popup[0]?.showpopup == "AddIDProofHoroscope" ? <></> : popupOpen &&
          <CommonNewPopup closePopup={() => onPopupClose(false)} message={popUpContent}
            buttonClick={onPopupBtnClick} buttonName={buttonName} title={title} image={imageSrc} />     

      }

              {HoroIdProofPopup && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
            <AddIdProofHoroscopePopup
              onClose={() => {setHoroIdProofPopup(false); 
                if(dontshowtoaste){
                  setShowCLCnPopupotification(false)
                  setDontShowtoaste(false);
                }else{
                setShowCLCnPopupotification(true)
                }
              }}
              idproofStatus={idStatus}
              horoscopeStatus={horoStatus}
              isMuslim={isMuslim}
              onAddHoroscope={handleAddHoroscope} onAddIdProof={handleAddIdProof}
            />
            </div>
          )}

          {showTrustDocPopup && (
          // <div className="fixed inset-0 z-[999] flex items-center justify-center">
            <TrustDocPopup close={() => { setShowTrustPopup(false);}} editMyProfielData={editMyProfielData} isFrom="clctrustpage"  setShowTrustPopup={setShowTrustPopup} apiCallEditProfile={apiCallEditProfile}  onUploadComplete={handleUploadComplete} {...(passNotificationId && { notificationId: ProfileData?.popup[0]?.notificationId})}  passNotificationId={passNotificationId}/>
          // </div>
        )}

        {showTrustSuccessPopup && (
                <CommonSuccessPopup
                  close={closeTrustSuccessPopup}
                  title={trans('photos.success')}
                  content={trans('trust_mark.id_proof_uploaded_successfully')}
                />
              )}

          {showHoroIdPopup && (
            <CommonHoroPopup
            editMyProfileData={window.innerWidth >= 768 ? editMyProfielData : undefined}
            OnClose={(type, isFrom) => {
              if (window.innerWidth < 768) {
                if (type === "upload_via") {
                  setshowUploadHoroscope(true);
                  setIsFrom(isFrom);
                }
                setShowHoroIdPopup(false);
                addIdHorostatus();
              } else {
                setShowHoroIdPopup(false);
                addIdHorostatus();
              }
            }}
            isFrom={window.innerWidth >= 768 ? "clcRedirectionHoro" : "clcRedirection"}
             {...(passNotificationId !== "N" && { notificationId: ProfileData?.popup[0]?.notificationId, notifyId: ProfileData?.popup[0]?.notificationId })}
            // notificationId={ProfileData?.popup[0]?.notificationId}
            // notifyId={ProfileData?.popup[0]?.notificationId }
            apiCallEditProfile={window.innerWidth >= 768 ? apiCallEditProfile : undefined}
            HoroclcPage={window.innerWidth >= 768 ? "Y" : undefined}
            setShowingSuccessPopup={setShowingHoroPopup}
            addIdHorostatus={addIdHorostatus}
            passNotificationId={passNotificationId}
          />

              //  <CommonHoroPopup  editMyProfileData={editMyProfielData} OnClose={() => setShowHoroIdPopup(false)} isFrom={'clcRedirectionHoro'}  notificationId={notificationId} apiCallEditProfile={apiCallEditProfile} HoroclcPage={"Y"} setShowingSuccessPopup={setShowingSuccessPopup}/>
            
          )}
              

      
    {
      paymentCLCsmallPopup ? <PaymentCLCPopup  closePopup={()=> {setPaymentCLCsmallPopup(false); setShowCLCnPopupotification(true);}}  message={ProfileData?.popup[0]?.content} title={ProfileData?.popup[0]?.bannerHeader} matchesCount={ProfileData?.popup[0]?.count} popupModel={ProfileData?.popup[0]?.popup_model} onPayNow={onPayNowPage} bannerFooter={ProfileData?.popup[0]?.bannerFooter} />
       : paymentCLCbigPopup ? <PaymentCLCBigPopup  closePopup={()=> {setPaymentCLCbigPopup(false); setShowCLCnPopupotification(true);}}  message={ProfileData?.popup[0]?.content} title={ProfileData?.popup[0]?.bannerHeader} matchesCount={ProfileData?.popup[0]?.count} popupModel={ProfileData?.popup[0]?.popup_model} onPayNow={onPayNowPage} bannerFooter={ProfileData?.popup[0]?.bannerFooter} /> : null
    // paymentCLCsmallPopup ? <PaymentCLCPopup  closePopup={()=> setPaymentCLCsmallPopup(false)}  message="You’ve requested details from 50 profiles." title="No Responses Yet? Connect Instantly with a Calling Pack!" matchesCount={89} popupModel="Requests Count" onPayNow={onPayNowPage}/>
    //   : paymentCLCbigPopup ? <PaymentCLCBigPopup  closePopup={()=> setPaymentCLCbigPopup(false)}  message="You’ve requested details from 50 profiles." title="No Responses Yet? Connect Instantly with a Calling Pack!" matchesCount={92} popupModel="Requests Count" onPayNow={onPayNowPage}/> : null
    
    }
  

      { 
        ((privacyPhotoPopupOpen && ProfileData?.popup[0]?.showpopup == "PrivacyOption") || 
          photonewpopupOpen)  &&
          <CommonClcPhotoPopup
          closePopup={() => {
            if(ProfileData?.popup[0]?.showpopup == "AddPhoto"){
              setPhotoNewPopupOpen(false)
              setShowCLCnPopupotification(true);
            }else{
              setPrivacyPhotoPopupOpen(false)
              setPhotoNewPopupOpen(false)
              setShowCLCnPopupotification(true);
            }
          }} 
          isFrom ="AddPhoto"
          message={popUpContent}  
          onPhotoPopupClose={onPhotoPopupClose}
          setUploadPhotoSuccessPopup={ setUploadPhotoSuccessPopup}
          setshowUploadSuccessPopup={setshowUploadSuccessPopup}
          buttonClick={onPopupBtnClick} buttonName={buttonName} title={ProfileData?.popup[0]?.showpopup == "PrivacyOption" ? "Add Photo with Privacy Options" : "Add Photo"} 
          image={imageSrc} 
          />
      }


        {uploadPhotoSuccessPopup && (
              <CommonSuccessPopup
                close={() => {
                  setUploadPhotoSuccessPopup(false);
                }}
                title={trans('photos.success')}
                content={trans('photos.image_uploaded_successfully')}
                isFrom="photopreview"
              />
            )}


     {  clcaddphotopopup &&

     <ClcAddPhotoPopup 
      closePopup={() => {
        setClcAddPhotoPopup(false)
        setShowCLCnPopupotification(true);
      }} 
      isFrom="photopreview"
      message={popUpContent}  
      onPhotoPopupClose={onPhotoPopupClose}
      setUploadPhotoSuccessPopup={setUploadPhotoSuccessPopup}
      buttonClick={onPopupBtnClick} buttonName={buttonName} 
      subcontent ={ProfileData?.popup[0]?.content || location?.state?.notificationContent || location?.state?.notificationContent}
      title={ProfileData?.popup[0]?.showpopup == "PrivacyOption" ? "Add Photo with Privacy Options" : "Add Photo"} image={imageSrc}  
      />
    }
    

      {
        showcastepopup && ProfileData?.cleanClearExecution == true &&
        <CommonCastPopup
          profileDate={ProfileData}

          close={() => setShowCastePopup(false)} />
      }

      {
        showDoshaPopup &&
         <DoshamPopup
        onClose={() => setShowDoshaPopup(false)} profileId={ProfileData?.profileId}
      />
      }

      {
        showNotificationPermission &&
        <CommonNotificationAlertPopup
          icon={NotificationIcon}
          close={closePermission}
          content={<span>
          Get updates on your profile and matches from Kalyan Matrimony. <br />
          Click Allow to get updates
          </span>}
          isFrom = {"notification"}
          NotificatiorequestPermission={()=>{requestPermission()}}
        />
      }

      {
        (showTrailPackPopup && location?.pathname == RouteSegments.MATCH_LITE) &&

        <CommonQualityPopup OnClose={() => 
          {
          setShowTrailPackPopup(false);
           if(hideCLCnotification){
          setShowCLCnPopupotification(false)
           setHideCLCnotification(false);
          }else{
          setShowCLCnPopupotification(true)
          }    
        }}
         expiredateLine="Y" callBackApply={() => { fetchReminderPopups() }}/>
      }

      {
        (showTrailPackCompletePopup && location?.pathname == RouteSegments.MATCH_LITE) &&

        <CommonRewardPopup OnClose={() => setShowTrailPackCompletePopup(false)} specialClaim="Y"/>
      }
       {familyChatAllow && (
                  <CommonErrorPopup 
                  closePopup={() => {onClickTrack(EventName.V3_Site_Add_Family_Member_Popup_Close_Button,{[EventKeys.profileId]: ProfileData?.profileId,});setFamilyChatAllow(false)}} message={trans('family.include_your_family__friends_t')} 
                  buttonName={trans('family.add_members_now')}
                  buttonClick={()=>{onClickTrack(EventName.V3_Site_Add_Family_Member_Popup_Add_Members_Button,{[EventKeys.profileId]: ProfileData?.profileId,}); setFamilyChatAllow(false);navigate(RouteSegments.MATCH_GROUP)}} 
                  />
                )}
      {
          showParentNumPopup && (<ParentsPhonePopupLite
          close={(familyChatAllow) => {setShowParentNumPopup(false);if(familyChatAllow){setFamilyChatAllow(true)}}}
          title={trans('my_profile.add_parents_phone_number')}
          notificationId={localStorage.getItem("notificationId") ? localStorage.getItem("notificationId") : ProfileData?.popup[0]?.showpopup == "AddParentsNumber" ? ProfileData?.popup[0]?.showpopup == "AddParentsNumber" : ProfileData?.popup[0]?.showpopup == "AddParentsNumber_2" }
          callBackApply={() => { fetchReminderPopups() }}
          parentsIsdCode={ProfileData?.parentsIsdCode}
          parentsMobileNumber={ProfileData?.parentsMobileNumber}
          isFrom={"clcRedirection"}
          type = {localStorage.getItem("notificationFor") ? localStorage.getItem("notificationFor") : ProfileData?.popup[0]?.showpopup}
          handleFocus = {onPopupBtnClick}
          from={from}
          chromeNotiId={notificationId}
          showPopupNoti={ProfileData?.popup[0]?.notificationId}
          popupContent={popUpContent ? popUpContent : localStorage.getItem("notificationContent") ? localStorage.getItem("notificationContent") : ProfileData?.popup[0]?.content }
        />
        )
      }

      {showPaymentPopup && <PaymentPopup 
      count={ProfileData?.popup ? ProfileData?.popup[0]?.count : ""}
      message={ProfileData?.popup ? ProfileData?.popup[0]?.content : ""}
      onClose={onPaynowCancel}
      onPayNow={onPayNow}
      />}

      {showDescriptionPopup && (
        <ProfileDescriptionPopup
          data={ProfileData?.descriptionPopup?.[0]}
          onClose={() => setShowDescriptionPopup(false)} // Close handler
        />
      )}

      </>
      
      }

            <div className='font-Poppins-Regular bg-[#eae6df] h-full md:h-screen w-screen overflow-y-hidden overflow-hidden fixed'>
        <div className='hidden md:block w-full h-[8.7rem] md:h-0 lg:h-[9rem] bg-[#d10a11] absolute top-0' />
        <div className='flex w-full h-full overflow-x-hidden overflow-y-hidden md:items-center md:justify-center'>
          <div className={`overflow-hidden z-[1]  flex flex-col items-center justify-center `}>

            <div className='w-[100vw] xl:w-[86vw] lg:w-[95vw]'>
              <LiteNavBar isFrom='conversation' />
            </div>
            <div className=' overflow-hidden  overflow-x-hidden  md:rounded-none  w-[100vw] h-full grow xl:w-[86vw] lg:w-[95vw] md:h-[93vh] xl:h-[82vh] 2xl:h-[85vh]  lg:h-[80vh]'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default LiteLayout;
const KalyanToast = ({ onClose,onDismiss }) => {
  const navigate = useNavigate();
  const { onClickTrack } = useAnalytics();
  const { setCustomerChatClicked} = useContext(NavBarContext);

  const handleVisitNow =(e) => {
    e.preventDefault(); 
    onClickTrack(EventName.V3_Site_KMCare_Notification_Alert_Visit_Now_Button);
    onDismiss()
    setCustomerChatClicked(true)
    navigate(RouteSegments.CHAT_LITE, { state: { isFrom: "customercare" } });
  };

  // return(
  //   <div className="fixed top-8 right-8 z-50 bg-white border-t-4 border-l-4 border-[#d10a10] flex items-start p-3 min-w-[480px] max-w-xl">
  //   {/* Icon */}
  //   <div className="flex-shrink-0 mr-3 mt-1">
  //     <img
  //       src={kalyanlogo} // Use your logo variable or path
  //       alt="Kalyan Matrimony"
  //       className="w-12 h-12 object-cover rounded-full"
  //     />
  //   </div>
  //   {/* Content */}
  //   <div className="flex-1">
  //     <div className="font-bold text-[#222] text-[17px] mb-1">
  //       Not now? No worries!
  //     </div>
  //     <div className="text-[#444] text-[15px] font-medium">
  //     You can always find this again in your Kalyan Matrimony Customer Care chat.{" "}
  //     <a
  //        href="#"
  //       className="text-blue-700 font-bold hover:underline"
  //       onClick={handleVisitNow}
  //     >
  //       Visit Now.
  //     </a>
  //   </div>
  //   </div>
  //   {/* Close Button */}
  //   <button
  //     onClick={onClose}
  //     className="ml-3 mt-1 text-[#d10a10] hover:text-black transition p-1"
  //     aria-label="Close"
  //   >
  //     <svg width="18" height="18" fill="currentColor" viewBox="0 0 20 20">
  //       <path
  //         fillRule="evenodd"
  //         d="M10 8.586l4.95-4.95a1 1 0 111.414 1.414L11.414 10l4.95 4.95a1 1 0 01-1.414 1.414L10 11.414l-4.95 4.95a1 1 0 01-1.414-1.414L8.586 10l-4.95-4.95A1 1 0 115.05 3.636L10 8.586z"
  //         clipRule="evenodd"
  //       />
  //     </svg>
  //   </button>
  // </div>
  // );

  // ... existing code ...
return(
  <div className="fixed top-2 right-0 z-50 bg-white max-w-sm  flex items-start p-2 rounded-sm
                 md:p-3 md:top-6 md:right-4 md:inset-x-auto md:w-auto md:min-w-[480px] md:max-w-lg md:rounded-md
                 lg:min-w-[520px] xl:min-w-[560px] lg:top-6 lg:right-2 border-[5px]">
  {/* Icon */}
  <div className="flex-shrink-0 mr-2 mt-1 md:mr-3">
    <img
      src={kalyanlogo} // Use your logo variable or path
      alt="Kalyan Matrimony"
      className="h-10 w-10 rounded-full object-cover md:h-12 md:w-12"
    />
  </div>
  {/* Content */}
  <div className="flex-1">
    <div className="font-bold text-[#222] text-[15px] md:text-[16px] lg:text-[17px] mb-1">
      Not now? No worries!
    </div>
    <div className="text-[#444] text-[13px] font-medium md:text-[14px] lg:text-[15px]">
    You can always find this again in your Kalyan Matrimony Customer Care chat.{" "}
    <a
       href="#"
      className="text-blue-700 font-bold underline"
      onClick={handleVisitNow}
    >
      Visit Now.
    </a>
  </div>
  </div>
  {/* Close Button */}
  <button
    onClick={onClose}
    className="ml-2 mt-1 p-1 text-[#d10a10] transition hover:text-black md:ml-3"
    aria-label="Close"
  >
    <svg className="h-4 w-4 md:h-5 md:w-5" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M10 8.586l4.95-4.95a1 1 0 111.414 1.414L11.414 10l4.95 4.95a1 1 0 01-1.414 1.414L10 11.414l-4.95 4.95a1 1 0 01-1.414-1.414L8.586 10l-4.95-4.95A1 1 0 115.05 3.636L10 8.586z"
        clipRule="evenodd"
      />
    </svg>
  </button>
</div>
);
// ... existing code ...
}


  
 
